import React from 'react';

import { StyledAppContainer } from './styled';
import { QSGContextProvider } from './context/QSGContext';
import { useHistory } from './hooks/use-history';
import { DataServer } from './store/data-server';
import { FeatureAppStandalone } from './app/standalone';
import { useStore } from './store';
import { AlertMessage } from './components/Alert';
import { setNotificationMessage } from './store/slices/qsg/actions';
import { Router } from 'react-router-dom';

interface AppProps {
  baseUrl?: string;
}

export function App({}: AppProps) {
  const history = useHistory();

  const [state, dispatch] = useStore();
  const { notificationMessage } = state.qsg;

  return (
    <>
      {notificationMessage && (
        <AlertMessage
          title='Sorry'
          message={notificationMessage}
          onClose={() => dispatch(setNotificationMessage(''))}
        />
      )}

      <DataServer>
        <QSGContextProvider>
          <StyledAppContainer>
            <Router history={history}>
              <FeatureAppStandalone />
            </Router>
          </StyledAppContainer>
        </QSGContextProvider>
      </DataServer>
    </>
  );
}
